import React from "react";
import { AccentInfo } from "../../../StyledComponents";
import {
  TimelineChangeList,
  TimelineChangeRow,
  TimelineContent,
  TimelineMetaList,
  TimelineMetaRow,
  TimelineNewBadge,
  TimelineSection,
  TimelineSectionTitle,
  TimelineTitle,
  TimelineTitleRow,
} from "../TimelineLayout";

const formatDiscrepancyValue = (detail, value) => {
  if (value === 'Y') return 'YES'
  if (value === 'N') return 'NO'
  if (!value) return <AccentInfo>none</AccentInfo>
  if (detail.field.includes('Rate') || detail.field.includes('%')) {
    return `%${value.toLocaleString("en-US", {maximumFractionDigits: 2, minimumFractionDigits: 2})}`
  }
  if (detail.field.includes('Value') || detail.field.includes('Price') || detail.field.includes('Amount')) {
    return `${value.toLocaleString("en-US", {maximumFractionDigits: 2, minimumFractionDigits: 0})}`
  }
  return value
}

const DiscrepancyResolvedOrRejected = ({milestone}) => (
  <TimelineContent>
    <TimelineTitleRow>
      <TimelineTitle>{milestone.milestone}</TimelineTitle>
      {milestone.notify && <TimelineNewBadge>new</TimelineNewBadge>}
    </TimelineTitleRow>
    {(milestone.activeDiscrepancies && milestone.activeDiscrepancies > 0 ) &&
      <TimelineSectionTitle>
        {milestone.activeDiscrepancies} {milestone.activeDiscrepancies === 1 ? `Discrepancy remaining` : `Discrepancies remaining`}
      </TimelineSectionTitle>
    }
    <TimelineMetaList>
      <TimelineMetaRow>
        <span className="timeline-meta-label">updated by:</span>
        <span className="timeline-meta-value">{milestone.contributor}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">date:</span>
        <span className="timeline-meta-value">{milestone.date}</span>
      </TimelineMetaRow>
    </TimelineMetaList>
    <TimelineSection>
      <TimelineSectionTitle>Resolution detail</TimelineSectionTitle>
      <TimelineChangeList>
        <TimelineChangeRow>
          <span className="timeline-change-label">new value:</span>
          <span className="timeline-change-value">{formatDiscrepancyValue(milestone.details, milestone.details.new)}</span>
        </TimelineChangeRow>
        {!milestone.milestone.includes('Resolved') &&
          <TimelineChangeRow>
            <span className="timeline-change-label">public record:</span>
            <span className="timeline-change-value">{formatDiscrepancyValue(milestone.details, milestone.details.publicRecordValue)}</span>
          </TimelineChangeRow>
        }
      </TimelineChangeList>
    </TimelineSection>
  </TimelineContent>
)

export default DiscrepancyResolvedOrRejected
